import { ImageElement } from "@kontent-ai/gatsby-components";
import { ImageElementProps } from "@kontent-ai/gatsby-components/dist/image-element";
import React from "react";
import { transformImageUrl } from "@kontent-ai/delivery-sdk";
import { ImageFocalPoints } from "../../../types";
import AnimationWrapper, {
  AnimationBehaviors,
} from "../../containers/AnimationWrapper";

interface ImageProps extends ImageElementProps {
  focalPoint?: ImageFocalPoints;
  animation?: AnimationBehaviors;
}

export const KontentImageElement: React.FC<ImageProps> = ({
  animation,
  ...props
}) => {
  if (!props.image?.url) return null;
  const image = {
    url: props.image.url,
    height: props.image.height,
    width: props.image.width,
    description: props.image.description,
  };

  const options = { quality: 85 };

  if (props.focalPoint && props.focalPoint !== "center") {
    const focalPoints = props.focalPoint?.split("_");

    const y = focalPoints[0] === "bottom" ? 1.0 : 0.0;
    const x = focalPoints[1] === "right" ? 1.0 : 0.0;

    const src = transformImageUrl(props?.image?.url)
      .withAutomaticFormat()
      .withWidth(props.width || props.image.width)
      .withHeight(props.height || props.image.height)
      .withFocalPointCrop(x, y, 1.0)
      .withFitMode("crop")
      .getUrl();

    return <img src={src} alt={props.image?.description} />;
  }

  if (props.width && props.image.width > props.width) {
    image.width = props.width;
    image.height =
      props.height || props.width * props.aspectRatio || image.height;
  }

  if (props.image.width > 3500) {
    const rawQualityScore = Math.round(
      100 - ((props.image.width - 3500) / 3500) * 100
    );

    const quality = Math.min(Math.max(rawQualityScore, 20), 85);

    options.quality = quality;
  }

  if (animation) {
    return (
      <AnimationWrapper behavior={animation}>
        <ImageElement {...props} options={options} image={image} />
      </AnimationWrapper>
    );
  }

  return <ImageElement {...props} />;
};
